import React, { useEffect, useState } from "react";
import { Tooltip, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import newStyled from "@emotion/styled";

import error_icon from "../../assets/error_100.png";
import loading_icon from "../../assets/progress-loading-bar.jpg"; // use your loader

const AttachmentCard = ({ attachment, previewConfig, onPreview }) => {
  const { src, clickable } = previewConfig;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const isHeic =
    attachment.file_name?.toLowerCase().endsWith(".heic") ||
    attachment.direct_url?.toLowerCase().endsWith(".heic");

  useEffect(() => {
    if (!src) return;

    setLoading(true);
    setError(false);

    const img = new Image();

    img.onload = () => {
      setLoading(false);
    };

    img.onerror = () => {
      setLoading(false);
      setError(true);
    };

    img.src = src;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src]);

  let displaySrc = src;

  if (loading) {
    displaySrc = loading_icon;
  } else if (error) {
    displaySrc = error_icon;
  }

  return (
    <div
      style={{
        flex: "0 0 150px",
        position: "relative",
        cursor: clickable && !error ? "pointer" : "default",
      }}
      onClick={() => clickable && !error && onPreview(attachment)}
    >
      <img
        src={displaySrc}
        alt={attachment.file_name}
        style={{
          width: "150px",
          height: "100px",
          borderRadius: "5px",
          objectFit: isHeic ? "cover" : "contain",
        }}
      />

      <Tooltip title={attachment.file_name}>
        <p
          style={{
            pointerEvents: "none",
            position: "absolute",
            bottom: 0,
            left: 0,
            margin: 0,
            padding: "5px 2px",
            background: "rgba(49,49,49,0.6)",
            color: "#fff",
            fontSize: "12px",
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {attachment.file_name}
        </p>
      </Tooltip>

      <a
        href={attachment.direct_url}
        download
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        style={{ position: "absolute", bottom: "2px", right: "2px" }}
      >
        <Tooltip title="Download">
          <BtnStyleAttachment size="small" shape="circle">
            <DownloadOutlined />
          </BtnStyleAttachment>
        </Tooltip>
      </a>
    </div>
  );
};

const BtnStyleAttachment = newStyled(Button)`
:where(.ant-btn.ant-btn-circle.ant-btn-sm) {
  background-color: white !important;
}
`;

export default AttachmentCard;
